<template>
  <v-form>
    <v-row align="center" justify="center">
      <h3><b>{{$t('json.scansettings')}}</b></h3>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12"><v-text-field :disabled="disable || preview" @change="onChange" v-model="ScanSettings.Size" :label="$t('json.appSize')" :rules="rules.Size" required validate-on-blur ></v-text-field></v-col>
      <v-col cols="12"><v-text-field :disabled="disable || preview" @change="onChange" v-model="ScanSettings.Depth" :label="$t('json.appDepth')" :rules="rules.Depth" required validate-on-blur ></v-text-field></v-col>
      <v-col cols="12"><v-text-field :disabled="disable || preview" @change="onChange" v-model="ScanSettings.DPI" :label="$t('json.appDPI')" :rules="rules.DPI" type="number" required validate-on-blur ></v-text-field></v-col>
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="onChange" v-model="ScanSettings.Duplex" :label="$t('json.appDuplex')" :rules="rules.Duplex" validate-on-blur ></v-switch></v-col>
    </v-row>
    <v-row align="center" justify="center">
      <h3><b>{{$t('json.separatorsetting')}}</b></h3>
    </v-row>
    <v-row>
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="(v) => { if(v) { this.changeSeparator('circlestamp') } else { this.changeSeparatorFalse(v) } this.onChange(v) }" v-model="ScanSettings.AutoSeparator" :label="$t('json.appAutoSeparator')" :rules="rules.AutoSeparator" validate-on-blur ></v-switch></v-col>
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="(v) => { if(v) { if(v) { this.changeSeparator('singlepage') } else { this.changeSeparatorFalse(v) } } this.onChange(v) }" v-model="ScanSettings.AutoSinglePageDocuments" :label="$t('json.appAutoSinglePageDocuments')" :rules="rules.AutoSinglePageDocuments" validate-on-blur ></v-switch></v-col>
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="(v) => { if(v) { this.changeSeparator('file') } else { this.changeSeparatorFalse(v) } this.onChange(v) }" v-model="ScanSettings.FileSeparator" :label="$t('json.appFileSeparator')" :rules="rules.AutoSeparator" validate-on-blur ></v-switch></v-col>
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="(v) => { if(v) { this.changeSeparator('barcode') } else { this.changeSeparatorFalse(v) } this.onChange(v) }" v-model="ScanSettings.BarcodeSeparator" :label="$t('json.appBarcodeSeparator')" :rules="rules.BarcodeSeparator" validate-on-blur ></v-switch></v-col>
      <v-col cols="12" v-show="ScanSettings.BarcodeSeparator"><v-switch :disabled="disable || preview" @change="onChange" v-model="ScanSettings.DoubleDetection" :label="$t('app.sform.doubledetect')" ></v-switch></v-col>
      <v-col cols="12" v-show="ScanSettings.BarcodeSeparator"><v-text-field :disabled="disable || preview" @change="onChange" v-model="ScanSettings.BarcodeRegexp" :label="$t('json.appBarcodeRegexp')" :rules="rules.BarcodeRegexp" validate-on-blur ></v-text-field></v-col>
      <v-col cols="12" v-show="ScanSettings.BarcodeSeparator"><v-select :disabled="disable || preview" @change="onChange" v-model="ScanSettings.BarcodeModel" :label="$t('json.appBarcodeModel')" :items="barcodeItems" item-text="name"  item-value="val"></v-select></v-col>
      <v-col cols="12" v-show="ScanSettings.BarcodeSeparator"><v-select :disabled="disable || preview" @change="onChange" v-model="ScanSettings.BarcodeDirection" :label="$t('json.appBarcodeDirection')" :items="barcodeDirections" item-text="name"  item-value="value"></v-select></v-col>
      <v-col cols="12" v-show="ScanSettings.BarcodeSeparator"><v-select :disabled="disable || preview" @change="onChange" v-model="ScanSettings.BarcodeArea" :label="$t('json.appBarcodeArea')" :items="barcodeAreas" item-text="name"  item-value="value"></v-select></v-col>
    </v-row>
  </v-form>
</template>

<script>
import Models from '@/Models'
import DataTypes from '../DataTypes'
import useMetaLicense from '../MetaLicense'
export default {
  name: 'ScanSettings',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      barcodeItems: [],
      barcodeDirections: [{ name: 'All', value: 'SDTREADDIRECTION_ALL' }, { name: 'Bottom to Top', value: 'SDTREADDIRECTION_BTT' }, { name: 'Right to Left', value: 'SDTREADDIRECTION_RTL' }, { name: 'Left to Right', value: 'SDTREADDIRECTION_LTR' }, { name: 'Top to Bottom', value: 'SDTREADDIRECTION_TTB' }],
      barcodeAreas: [{ name: 'Full', value: 'FULL' }, { name: 'Top 1/3', value: 'TOP_1_3' }, { name: 'Top 1/2', value: 'TOP_1_2' }, { name: 'Bottom 1/2', value: 'BOTTOM_1_2' }, { name: 'Bottom 1/3', value: 'BOTTOM_1_3' }],
      typeHelper: new DataTypes(),
      rules: {
        BatchDeleteTime: [(v) => !!v || this.$i18n.t('json.ruleempty')],
        ExportFolder: [],
        Duplex: [],
        DPI: [(v) => !!v || this.$i18n.t('json.ruleempty')],
        Depth: [(v) => !!v || this.$i18n.t('json.ruleempty')],
        Size: [(v) => !!v || this.$i18n.t('json.ruleempty')],
        BarcodeSeparator: [],
        BarcodeRegexp: [],
        BarcodeModel: [(v) => !!v || this.$i18n.t('json.ruleempty')],
        AutoSeparator: [],
        AutoSinglePageDocuments: [],
        BarcodeDirection: [(v) => !!v || this.$i18n.t('json.ruleempty')],
        BarcodeArea: [(v) => !!v || this.$i18n.t('json.ruleempty')],
        AutoSave: []
      }
    }
  },
  computed: {
    ScanSettings () {
      return this.props.ScanSettings
    }
  },
  methods: {
    changeSeparatorFalse (val) {
      console.log('changeSwitchFalse', val)
      window.setTimeout(() => {
        if (!this.ScanSettings.AutoSinglePageDocuments &&
        !this.ScanSettings.AutoSeparator &&
        !this.ScanSettings.FileSeparator &&
        !this.ScanSettings.BarcodeSeparator) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
        window.setTimeout(() => { useMetaLicense.checkSeparation(this.$i18n.t('licenselimitexc')) }, 100)
      }, 150)
    },
    changeSeparator (type) {
      if (type === 'barcode') {
        this.ScanSettings.AutoSinglePageDocuments = false
        this.ScanSettings.AutoSeparator = false
        this.ScanSettings.FileSeparator = false
        if (!this.ScanSettings.BarcodeSeparator) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
      } else if (type === 'singlepage') {
        this.ScanSettings.BarcodeSeparator = false
        this.ScanSettings.AutoSeparator = false
        this.ScanSettings.FileSeparator = false
        if (!this.ScanSettings.AutoSinglePageDocuments) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
      } else if (type === 'circlestamp') {
        this.ScanSettings.BarcodeSeparator = false
        this.ScanSettings.AutoSinglePageDocuments = false
        this.ScanSettings.FileSeparator = false
        if (!this.ScanSettings.AutoSeparator) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
      } else if (type === 'file') {
        this.ScanSettings.BarcodeSeparator = false
        this.ScanSettings.AutoSinglePageDocuments = false
        this.ScanSettings.AutoSeparator = false
        if (!this.ScanSettings.FileSeparator) {
          this.ScanSettings.AutoSinglePageDocuments = true
        }
      }
      window.setTimeout(() => { useMetaLicense.checkSeparation(this.$i18n.t('licenselimitexc')) }, 150)
    },
    async onChange (val) {
      this.$emit('changeSettings')
    }
  },
  created () {
    this.barcodeItems.push(...Models.BarcodeTypes)
  }
}
</script>
